var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stats"},[_c('SectionTitle',{attrs:{"sectionText":_vm.title}}),_vm._l((_vm.items),function(item,idx){return _c('StatisticsData',{key:idx,attrs:{"icon":item.icon,"title":item.text,"subText":_vm.subText,"info":_vm.infos[idx]}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }